<template>
    <div class="box">
        <span class="version" v-if="mode !== 'production'">{{ $t('version') }}:{{ appVersion }}</span>
        <el-header>
            <div class="header_logo">
                <img
                    v-if="$i18n.locale === 'english'"
                    class="lang-no-active"
                    src="@/assets/head-icon2.png"
                    @click="en"
                />
                <img v-else class="lang-no-active" src="@/assets/head-grey-icon2.png" @click="en" />

                <img
                    v-if="$i18n.locale === 'chinese'"
                    class="img2 lang-no-active"
                    src="@/assets/head-icon1.png"
                    @click="zh"
                />
                <img v-else class="img2 lang-no-active" src="@/assets/head-grey-icon1.png" @click="zh" />
            </div>
            <div class="header_text">
                <a :href="$i18n.locale === 'chinese' ? '/zh' : '/en'"><img src="@/assets/Header-Logo.png" alt="" /></a>
            </div>
            <div class="header_button">
                <button id="btn" @click="changeActive(0)" @click.prevent="showMe" v-if="token === ''">
                    <a tag="a">{{ $t('login') }}</a>
                </button>
                <button id="btn" :class="{ active: $route.path.indexOf('OrderManagement') != -1 }" v-else>
                    <!-- <router-link :to="'/orderManagement/charter/quickOrder/'" tag="a">{{ $t('me') }}</router-link> -->
                    <a
                        :href="
                            '/' +
                            ($i18n.locale === 'chinese' ? 'zh' : 'en') +
                            `/orderManagement/charter/${+userType === 1 ? 'quickOrder' : 'orderManagement'}/`
                        "
                    >
                        {{ $t('me') }}
                    </a>
                </button>
                <button
                    id="btn"
                    :class="{
                        active: $route.path.indexOf(`/${$i18n.locale}/news`) != -1,
                    }"
                >
                    <router-link @click="changeActive(1)" :to="`/${$i18n.locale}/news`" tag="a">{{
                        $t('news')
                    }}</router-link>
                </button>
                <button id="btn" :class="{ active: $route.path == `/${$i18n.locale}/contact` }">
                    <router-link @click="changeActive(2)" :to="`/${$i18n.locale}/contact`" tag="a">{{
                        $t('contact')
                    }}</router-link>
                </button>
                <button id="btn" :class="{ active: $route.path == `/${$i18n.locale}/team` }">
                    <router-link @click="changeActive(3)" :to="`/${$i18n.locale}/team`" tag="a">{{
                        $t('team')
                    }}</router-link>
                </button>
            </div>
        </el-header>
        <nav class="nav">
            <div>
                <img src="@/assets/nav_phone.png" alt="" />
                <p>
                    {{ $t('call') }}：{{ configInfo.serviceMobileList[0] }} &nbsp;<span
                        >({{ configInfo.officeTime }})</span
                    >
                </p>
            </div>
            <!-- <router-link active-class="navActive" :to="`/${$i18n.locale}/home`">{{ $t('charter') }}</router-link> -->
            <a :href="'/' + ($i18n.locale === 'chinese' ? 'zh' : 'en') + '/charter'">{{ $t('charter') }}</a>
            <!-- <router-link active-class="navActive" :to="`/${$i18n.locale}/yachtTours`">{{ $t('tours') }}</router-link> -->
            <a href="https://skywalkertours.ae/" target="_blank">{{ $t('tours') }}</a>
            <router-link active-class="navActive" :to="`/${$i18n.locale}/superYachts`">{{ $t('super') }}</router-link>
            <router-link active-class="navActive" :to="`/${$i18n.locale}/waterSports`">{{
                $t('waterSports')
            }}</router-link>
            <router-link active-class="navActive" :to="`/${$i18n.locale}/fishing`">{{ $t('fishing') }}</router-link>

            <!-- <router-view /> -->
        </nav>
        <FloatAside />
        <el-dialog
            class="book_dialog"
            :visible.sync="showLogin"
            @close="closeLogin"
            :lock-scroll="false"
            :modal-append-to-body="false"
        >
            <LoginForm ref="child" :enquirys="enquirys" @submit="login" :showLogin="showLogin" />
        </el-dialog>
    </div>
</template>
<script>
import LoginForm from './loginForm.vue'
import config from '@/api/config'
import FloatAside from './FloatAside.vue'
import { mapState } from 'vuex'
export default {
    data() {
        return {
            showLogin: false,
            showQR: false,
            enquirys: '',
            appVersion: config.appVersion,
            mode: config.mode,
        }
    },
    components: {
        LoginForm,
        FloatAside,
    },
    methods: {
        zh() {
            if (this.$i18n.locale === 'chinese') {
                this.$message({
                    message: '已经是当前语言，无需再次切换',
                    type: 'warning',
                })
            } else {
                this.$confirm('确定要切换语言吗？', '提示', {
                    confirmButtonText: '切换',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    this.$i18n.locale = 'chinese'
                    localStorage.setItem('languageSet', this.$i18n.locale)
                    // location.reload();
                    let path = this.$route.path
                    if (this.$route.query.newsId) {
                        this.$router.push(`/chinese/news`)
                    } else {
                        this.$router.push(`/chinese${path.slice(8)}`)
                    }
                })
            }
        },
        en() {
            if (this.$i18n.locale === 'english') {
                this.$message({
                    message: 'The current language does not need to be switched again.',
                    type: 'warning',
                })
            } else {
                this.$confirm('Are you sure you want to switch languages?', 'prompt', {
                    confirmButtonText: 'switch',
                    cancelButtonText: 'cancel',
                    type: 'warning',
                }).then(() => {
                    this.$i18n.locale = 'english'
                    localStorage.setItem('languageSet', this.$i18n.locale)
                    // location.reload();
                    let path = this.$route.path
                    if (this.$route.query.newsId) {
                        this.$router.push(`/english/news`)
                    } else {
                        this.$router.push(`/english${path.slice(8)}`)
                    }
                })
            }
        },
        async login() {
            if (this.token !== '') {
                this.showLogin = false
                // this.$router.push(`orderManagement/charter/quickOrder`)
                location.href =
                    '/' +
                    (this.$i18n.locale === 'chinese' ? 'zh' : 'en') +
                    `/orderManagement/charter/${+this.userType === 1 ? 'quickOrder' : 'orderManagement'}/`
                this.activeIndex = 0
            }
        },
        showMe() {
            this.showLogin = true
        },
        changeActive(activeIndex) {
            // document.querySelectorAll('#btn')?.classList.remove('active');
            document.querySelectorAll('#btn').forEach(item => item.classList.remove('active'))
            document.querySelectorAll('#btn')[activeIndex].classList.add('active')
        },
        closeLogin() {
            document.querySelectorAll('#btn').forEach(item => item.classList.remove('active'))
        },
    },
    computed: {
        ...mapState({
            token: state => state.login.token,
            userType: state => state.login.userType,
            configInfo: state => state.baseConfig.baseConfigInfo,
        }),
    },
    created() {},
}
</script>
<style lang="less">
.version {
    color: #1eaf00;
    font-weight: bold;
    font-size: 20px;
    position: absolute;
    top: 0;
    left: 100px;
    z-index: 999999999999;
}
.header_logo {
    .img2 {
        margin-left: -7px;
    }
}
.header_button {
    button {
        a {
            display: block;
            width: 100%;
            height: 100%;
            font-family: SegoeUI-Semibold;
        }
    }
}
.header_button .active {
    // background-image: linear-gradient(0deg, #f5b53a 0%, #fccd72 100%);
    background: linear-gradient(180deg, #f5b53a 0%, #fccd72 100%);
    // border-image: linear-gradient(0deg, #f5b53a 0%, #fccd72 100%);
    border-color: transparent;
    border-radius: 5px;
    a {
        color: #020b3b;
        font-weight: 700;
    }
}
.nav .navActive {
    color: #d9b061;
}
.lang-no-active::after {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>
